// VENDOR
import { set } from "dot-prop-immutable";
// ACTION TYPES
import { GET_QR_CODE } from "./actionTypes";

const initialState = {
  isLoading: false,
  error: null,
  reason: null,
  qrcode: null,
};

const controlPointDynamicPortalReducer = (state = initialState, action) => {
  const { type, data } = action;

  if (type === GET_QR_CODE) {
    if (data.qrcode !== null) {
      state = set(state,"qrcode", data.qrcode);
    }
    state = set(state, "isLoading", data.isLoading || false);
    state = set(state, "error", data.error || null);
    state = set(state, "reason", data.reason || null);

  }

  return state;
};

export default controlPointDynamicPortalReducer;